module.exports = "/assets/5dc5f3593c990a0ae0c55b4d48dc0779.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/cars/assets/logos/AL.png
// module id = 758
// module chunks = 0